<!-- <template>
  <section class="hero">
    <div class="hero-container">
      <div class="hero-content">
        <h1 class="hero-title">
          <transition name="fade" mode="out-in">
            <span :key="currentPhraseIndex" v-html="currentPhrase"></span>
          </transition>
        </h1>
        <div class="sections">
          <div class="publications-section">
            <p class="publications-text"> {{ $t('heroHighlightTexe2') }} </p>
            <router-link :to="{ name: $t('publicationsRouterName') }" tag="a" class="publications-button">{{
              $t('heroHighlightButtonText') }}</router-link>
          </div>
          <div class="publications-section">
            <p class="publications-text"> {{ $t('prepareControlFR22') }} </p>
            <router-link :to="{ name: $t('financial-reports-templates') }" tag="a" class="prepare-button">{{
              $t('prepareControlFR22') }}</router-link>
          </div>
        </div>

      </div>
      <div class="hero-image">
        <img src="../../assets/Hero_Image.png" alt="Hero illustration" loading="lazy">
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  data() {
    return {
      phrases: [
        this.$t('heroPhrase1'),
        this.$t('heroPhrase2'),
        this.$t('heroPhrase3')
      ],
      currentPhraseIndex: 0,
      intervalId: null,
    }
  },
  computed: {
    ...mapGetters(["getSelectedLanguage"]),
    currentPhrase() {
      return this.phrases[this.currentPhraseIndex]
    }
  },
  mounted() {
    this.startCarousel()
  },
  beforeDestroy() {
    this.stopCarousel()
  },
  methods: {
    startCarousel() {
      this.intervalId = setInterval(() => {
        this.currentPhraseIndex = (this.currentPhraseIndex + 1) % this.phrases.length
      }, 4000)
    },
    stopCarousel() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
    },
    loadPhrases() {
      this.phrases = [
        this.$t('heroPhrase1'),
        this.$t('heroPhrase2'),
        this.$t('heroPhrase3')
      ];
    }
  },
  watch: {
    getSelectedLanguage() {
      this.loadPhrases();
    }
  },
}
</script>

<style>
.hero {
  background: radial-gradient(circle at center,
      #BDCDFB 0%,
      var(--secondary-color) 100%);
  padding: 2% 7%;
  /* min-height: 500px; */
  display: flex;
  align-items: center;
  width: 100%;
}

.hero-container {
  width: 100%;
  display: flex;
  gap: 10px;
  /* align-items: center; */
  align-items: stretch;
}

.hero-content,
.hero-image {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.hero-content {
  width: 65%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  margin-top: auto;
}

.hero-title {
  font-size: 50px;
  line-height: 70px;
  font-weight: 700;
  margin-bottom: 2.5rem;
  /* color: #1a1a1a; */
  color: #111;
  /* letter-spacing: -0.02em; */
  width: 90%;
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.highlight {
  color: var(--main-color);
  position: relative;
  display: inline-block;
}

.highlight::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: var(--main-color);
  transform: scaleX(0);
  transform-origin: right;
  transition: transform 0.3s ease;
}

.hero-content:hover .highlight::after {
  transform: scaleX(1);
  transform-origin: left;
}

.sections {
  display: flex;
  gap: 25px;
  width: 95%;
}

.publications-section {
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(8px);
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  width: 50%;
  /* margin-top: auto; */
  max-height: 200px;
  min-height: 170px !important;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.publications-text {
  font-size: 24px;
  line-height: 1.2;
  font-weight: 500;
  color: #465481;
  /* margin-bottom: 2rem; */
  margin-bottom: auto;
}

.prepare-button {
  display: inline-block;
  background-color: var(--main-color);
  /* background-color: transparent; */
  /* color: var(--main-color); */
  color: white;
  padding: 0.75rem;
  border-radius: 0.5rem;
  /* border: 2px solid var(--main-color); */
  /* font-size: 1.125rem; */
  font-size: 20px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  text-align: center;
  /* width: 100%; */
  box-shadow: 0 2px 4px rgba(176, 198, 249, 0.2);
  margin-top: 10px;
}

.prepare-button:hover {
  color: white;
  /* background-color: var(--main-color); */
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(176, 198, 249, 0.3);
}

.publications-button {
  display: inline-block;
  background-color: #F68600;
  color: white;
  padding: 0.75rem;
  border-radius: 0.5rem;
  /* font-size: 1.125rem; */
  font-size: 20px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  text-align: center;
  /* width: 40%; */
  box-shadow: 0 2px 4px rgba(246, 134, 0, 0.2);
  margin-top: 10px;
}

.publications-button:hover {
  background-color: #f69927;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(246, 134, 0, 0.3);
  text-decoration: none;
  color: var(--secondary-color);
  text-decoration: underline;
}

.hero-image {
  width: 35%;
  position: relative;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  max-height: 320px;
}

.hero-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.6s ease;
}

.hero-image:hover img {
  transform: scale(1.05);
}

.slide-fade-enter-active {
  transition: all 0.8s ease;
  position: relative;
}

.slide-fade-leave-active {
  transition: all 0.8s ease;
  position: relative;
}

.slide-fade-enter-from {
  transform: translateY(20px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.phrase {
  display: block;
  position: relative;
  animation: textReveal 0.8s ease forwards;
}

@keyframes textReveal {
  0% {
    transform: scale(0.95);
    opacity: 0;
  }

  50% {
    transform: scale(1.02);
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}


@media (max-width: 1200px) {
  .hero-title {
    font-size: 38px;
    line-height: 45px;
    margin-bottom: 20px;
  }

  .publications-text {
    /* font-size: 1.125rem; */
    font-size: 18px;

  }

  .publications-button {
    /* width: 50%; */
  }
}

@media (max-width: 992px) {
  .sections {
    width: 100%;
  }

  .hero-container {
    flex-direction: column;
    gap: 2rem;
  }

  .hero-content,
  .hero-image {
    width: 100%;
  }

  .hero-content,
  .hero-image {
    width: 100%;
    /* Remove the fixed height for the image */
  }

  .hero-title,
  .publications-section {
    width: 100%;
  }

  .publications-button {
    /* width: 40%; */
  }

  .hero-image {
    height: 400px;
  }
}

@media (max-width: 768px) {
  .sections {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .hero {
    padding: 4rem 7%;
  }

  .hero-title {
    /* font-size: 1.75rem; */
  }

  .publications-section {
    padding: 1.5rem;
    max-height: unset;
    min-height: unset !important;
  }

  .publications-text {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .publications-button {
    /* width: 50%; */
  }

  .hero-image {
    height: 300px;
  }
}

@media (max-width: 480px) {
  .hero {
    padding: 3rem 7%;
  }

  .hero-title {
    /* font-size: 1.5rem; */
    font-size: 30px;
    line-height: 35px;
  }

  .hero-image {
    height: 250px;
  }

  .publications-button {
    width: 100%;
  }
}
</style> -->

<template>
  <section class="hero">
    <div class="hero-container">
      <!-- LEFT: Headline + subtitle -->
      <div class="hero-content">
        <h1 class="hero-title" v-html="$t('heroMainTitle')"></h1>
        <p class="hero-subtitle">{{ $t('heroSubtitle') }}</p>
      </div>

      <!-- RIGHT: Two CTA cards -->
      <div class="hero-cards">
        <!-- Card 1: Blue (primary) -->
        <div class="hero-card hero-card--blue">
          <div class="hero-card__icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
            </svg>
          </div>
          <h2 class="hero-card__title">{{ $t('heroCard1Title') }}</h2>
          <p class="hero-card__desc">{{ $t('heroCard1Desc') }}</p>
          <router-link :to="{ name: $t('publicationsRouterName') }" class="hero-card__btn hero-card__btn--white">
            {{ $t('heroCard1Btn') }} <span class="btn-arrow">→</span>
          </router-link>
          <div class="hero-card__bars" aria-hidden="true">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <!-- Card 2: Orange -->
        <div class="hero-card hero-card--orange">
          <div class="hero-card__icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
            </svg>
          </div>
          <h2 class="hero-card__title">{{ $t('heroCard2Title') }}</h2>
          <p class="hero-card__desc">{{ $t('heroCard2Desc') }}</p>
          <router-link :to="{ name: $t('financial-reports-templates') }" class="hero-card__btn hero-card__btn--white-orange">
            {{ $t('heroCard2Btn') }} <span class="btn-arrow">→</span>
          </router-link>
          <div class="hero-card__bars" aria-hidden="true">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters(["getSelectedLanguage"]),
  },
}
</script>

<style>
.hero {
  padding: 3rem 7%;
  width: 100%;
}

.hero-container {
  width: 100%;
  display: flex;
  max-width: 1440px;  
  margin: 0 auto;  
  gap: 3rem;
  align-items: center;
}

.highlight {
  color: var(--main-color);
  position: relative;
  display: inline-block;
}

/* LEFT: text block */
.hero-content {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
}

.hero-title {
  font-size: 56px;
  line-height: 1.2;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.hero-subtitle {
  font-size: 20px;
  line-height: 1.6;
  color: #6b7280;
  margin: 0;
  max-width: 90%;
}

/* RIGHT: two cards */
.hero-cards {
  width: 50%;
  display: flex;
  gap: 1rem;
  align-items: stretch;
}

.hero-card {
  flex: 1;
  border-radius: 18px;
  padding: 1.75rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-height: 260px;
  position: relative;
  overflow: hidden;
  isolation: isolate;
  box-shadow: 0 16px 35px rgba(15, 23, 42, 0.14);
}

.hero-card--blue {
   background:
    radial-gradient(circle at 0% 0%, rgba(255,255,255,0.20), transparent 34%),
    linear-gradient(145deg, #2866e8 0%, #1749bd 100%);
  color: white;
}

.hero-card--orange {
 background:
    radial-gradient(circle at 0% 0%, rgba(255,255,255,0.22), transparent 34%),
    linear-gradient(145deg, #ff9224 0%, #ef5f0b 100%);
  color: white;
}

.hero-card__icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.hero-card__icon svg {
  width: 26px;
  height: 26px;
  color: white;
}

.hero-card__title {
  font-size: 24px;
  font-weight: 700;
  color: white;
  line-height: 1.3;
  margin: 0;
}

.hero-card__desc {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.5;
  margin: 0;
  flex-grow: 1;
}

.hero-card__btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  align-self: flex-start;
  margin-top: auto;
}

.hero-card__btn--white {
  background: white;
  color: #2563eb;
}

.hero-card__btn--white:hover {
  background: #f0f4ff;
  transform: translateX(2px);
  text-decoration: none;
  color: #1d4ed8;
}

.hero-card__btn--white-orange {
  background: white;
  color: #ea580c;
}

.hero-card__btn--white-orange:hover {
  background: #fff7ed;
  transform: translateX(2px);
  text-decoration: none;
  color: #c2410c;
}

.btn-arrow {
  transition: transform 0.2s ease;
}

.hero-card__btn:hover .btn-arrow {
  transform: translateX(3px);
}

/* Decorative background circle on cards */
/* .hero-card::before {
  content: '';
  position: absolute;
  top: -40px;
  right: -40px;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  pointer-events: none;
} */

.hero-card__bars {
  position: absolute;
  right: 18px;
  bottom: 16px;
  height: 82px;
  width: 112px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 8px;
  opacity: 0.16;
  z-index: 1;
  pointer-events: none;
}

.hero-card__bars span {
  width: 13px;
  border-radius: 8px 8px 0 0;
  background: rgba(255, 255, 255, 0.95);
}

.hero-card__bars span:nth-child(1) { height: 24px; }
.hero-card__bars span:nth-child(2) { height: 40px; }
.hero-card__bars span:nth-child(3) { height: 56px; }
.hero-card__bars span:nth-child(4) { height: 72px; }
.hero-card__bars span:nth-child(5) { height: 48px; }

/* Responsive */
@media (max-width: 1100px) {
  .hero-title {
    font-size: 34px;
  }
}

@media (max-width: 900px) {
  .hero-container {
    flex-direction: column;
  }

  .hero-content,
  .hero-cards {
    width: 100%;
  }

  .hero-title {
    font-size: 30px;
  }

  .hero-subtitle {
    max-width: 100%;
  }
}

@media (max-width: 540px) {
  .hero-cards {
    flex-direction: column;
  }

  .hero-card {
    min-height: unset;
  }

  .hero-title {
    font-size: 26px;
  }
}
</style>